import React, { useMemo, memo, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

import { createData, createOptions } from './SonarVerticalBarsUtils';
import NoChartsData from '../../no-charts-data/NoChartsData';
import VisitWebsiteContextMenu from '../../../visit-website-context-menu/VisitWebsiteContextMenu';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export const VERTICAL_BARS_CONTEXT_MENU = 'vertical-bars/VisitWebsiteContextMenu';

function VerticalBars({ height, reverseTrendGroup, customTooltip, title, data, dataKey, showTrend, showScore }) {
  const theme = useSelector((state) => state.global.theme);

  const options = useMemo(() => {
    return createOptions({
      theme,
      title,
      data,
      customTooltip,
      dataKey,
      showTrend,
      showScore,
    });
  }, [theme, title, customTooltip, data, dataKey, showTrend, showScore]);

  const chartData = useMemo(() => {
    return createData({
      data,
      reverseTrendGroup,
      dataKey,
      theme,
      showTrend,
      showScore,
    });
  }, [reverseTrendGroup, data, dataKey, theme, showTrend, showScore]);

  //fix tooltip on unmount
  useEffect(() => {
    return () => {
      const tooltip = document.getElementById('chartJsFancyColumnsNewTooltip');
      if (tooltip) {
        tooltip.remove();
      }
    };
  }, []);

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  if (!data?.length) {
    return <NoChartsData height={height} />;
  }

  return (
    <div style={{ height }}>
      <Bar options={options} data={chartData} onContextMenu={handleContextMenu} />
      <VisitWebsiteContextMenu id={VERTICAL_BARS_CONTEXT_MENU} />
    </div>
  );
}

export default memo(VerticalBars);
